import { forwardRef } from "react";
import { Fab, Icon } from '@mui/material';

const ScrollDownBtn = forwardRef((props,ref) =>  (
    <Fab ref={ref} sx={{position: 'fixed', bottom: 90, left: '50%', display:"none"}} size="small" aria-label="New message" onClick={props.scroolParentToView} color="primary">
        <Icon>arrow_down</Icon>
    </Fab>
  ))

export default ScrollDownBtn